import { ReactNode } from "react";

import { Footer, Nav } from "features/Nav";

// import AppInstall from "components/AppInstall";
import GlobalLayout from "./GlobalLayout";

export default function DefaultLayout({ children }: { children: ReactNode }) {
  return (
    <GlobalLayout>
      <Nav />
      {children}
      <Footer />
    </GlobalLayout>
  );
}

export const DefaultLayoutWrapper = page => DefaultLayout({ children: page });
